import script from "./CommonTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonTabs.vue?vue&type=script&setup=true&lang=ts"

import "./CommonTabs.vue?vue&type=style&index=0&id=b2ad4e4c&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2ad4e4c"]])

export default __exports__